interface StatusMessageProps {
  message: string | null;
}

export function StatusMessage({ message }: StatusMessageProps) {
  if (!message) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 text-sm text-gray-500 bg-gray-50 border-t">
      <div className="animate-pulse flex items-center gap-2">
        <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" />
        <span>{message}</span>
      </div>
    </div>
  );
}
